module.exports = __webpack_public_path__ + "static/media/game-Ldoor.f550d26c.png";